import type { FaireProductEntity } from "../../entity_types/product";

export const p_dtwzganp4h: FaireProductEntity = {
  token: "p_dtwzganp4h",
  type: "product",
  name: "Sullivan Two-Toned Hoops",
  brandToken: "b_fcca911f",
  brandName: "Mod + Jo",
  imageUrl:
    "https://cdn.faire.com/fastly/42c5f65d65a784839745dfe2570318210e46fc2a24f3426115c5b0a4d52c5f64.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fc8883b5da84b3e50a3ef60bd36c95a9c5308846dd16f6f2345d544620716f93.jpeg",
  ],
  priceDollars: 39.5,
  description:
    "Cross paths with style with the Sullivan Two Tone Hoops. These medium-sized cross hoops feature a chic two-tone design that's perfect for going from work to weekend.  \n\nTarnish-resistant two-tone plating that is long-lasting with proper care\nStainless steel posts\n14mm inner\nNickel- and lead-free",
  tags: [],
  msrpDollars: 79,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:42.697Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
